import {DataSource, PlatformDataFeed, PlatformTrack} from "../../../types/dataSourceTypes";
import React, {useEffect, useState} from "react";
import {useTheme} from "../../../contexts/theme";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import {EventOfInterest} from "../../../types/jobDataTypes";
import {FormControl, FormControlLabel, Typography} from "@mui/material";
import StyledTextarea from "../../CommonComponents/StyledTextarea/StyledTextarea";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import StyledDataTimePicker from "../../CommonComponents/StyledDateTimePicker/StyledDataTimePicker";
import dayjs, {Dayjs} from "dayjs";
import StyledAutocomplete from "../../CommonComponents/StyledAutocomplete/StyledAutocomplete";
import StyledDropdown from "../../CommonComponents/StyledDropdown/StyledDropdown";
import StyledCheckBox from "../../CommonComponents/StyledCheckbox/StyledCheckBox";
import StyledSlider from "../../CommonComponents/StyledSlider/StyledSlider";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import {Competition} from "../../CommonComponents/OpenerCloserComponent/OpenerCloserComponent";
import {HighlightTypeObjects, visibleHighlightTypes} from "../../../utils/constants";
import KeyMomentJobComponent from "../../JobComponents/NewKeyMomentJobComponent";
import StyledCollapse from "../../CommonComponents/StyledCollapse/StyledCollapse";
import AutoPublication from "../../CommonComponents/AutoPublicationComponent/AutoPublicationComponent";
import {Option} from "../../../types/generic";
import StyledCheckBoxLabel from "../../CommonComponents/StyledCheckbox/StyledCheckBoxLabel";
import {OpenerCloserObject} from "../../../types/opernerCloserTypes";
import {FormJob, HighlightSettings, JobSettings} from "../../../types/jobTypes";
import {getJobOptions, getPresetConfigs} from "../../../queries/jobQueries";
import {getSocialOptions} from "../../../queries/socialQueries";
import {SocialPlatformOptionObject,} from "../../../types/socialTypes";
import SpinnerBox from "../../CommonComponents/SpinnerBox/SpinnerBox";
import {SupportedHighlightTypes} from "../../../types/highlightTypes";
import HighlightSetting from "../../CommonComponents/HighlightSetting/HighlightSetting";
import {capitilize} from "../../../utils/stringUtils";
import PreSetsConfig from "../../CommonComponents/PreSetsComponent/PreSetsConfig";
import StyledPopup from "../../CommonComponents/StyledPopup/StyledPopup";
import {getDefaultDataJob} from "../../../utils/jobUtils";

interface JobFormProps {
    job: FormJob,
    onSubmit: () => void,
    setJob: React.Dispatch<React.SetStateAction<FormJob>>,
    mode: 'create' | 'update'
    competition: Competition,
    eventId: string
    jobLoading?: boolean
    submitLabel?: string
}

const datasourceRoles = {
    "feed": "data_feed",
    "source": "src",
}

const trackRoles = {
    "video": "main_video",
    "audio": "main_audio",
}

const isDataFeedNeeded = process.env.REACT_APP_SPORT === 'football';
const dataSourceGridSize = isDataFeedNeeded ? 3 : 4;

const defaultJobData = getDefaultDataJob()

export default function JobForm({job, setJob, submitLabel, onSubmit, mode, competition, eventId, jobLoading}: JobFormProps) {
    const theme = useTheme();

    const [enableAutoPublicationAllEvents, setEnableAutoPublicationAllEvents] = useState<boolean>(false);

    const [socialPlatform, setSocialPlatform] = useState<Option | null>(null); // social
    const [socialOptions, setSocialOptions] = useState<SocialPlatformOptionObject>();

    const [tooltipText, setTooltipText] = useState<string>("");
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    const [allSkillSelected, setAllSkillSelected] = useState<boolean>(false);

    const [sourceDataSourcesOptions, setSourceDataSourcesOptions] = useState<DataSource[]>([])
    const [feedDataSourcesOptions, setFeedDataSourcesOptions] = useState<PlatformDataFeed[]>([])
    const [targetOptions, setTargetOptions] = useState<string[]>([])
    const [tagOptions, setTagOptions] = useState<string[]>([])
    const [needKafka, setNeedKafka] = useState(false)
    const [jobOptionsLoading, setJobOptionsLoading] = useState<boolean>(true);

    const [isHighlightSettingOpen, setIsHighlightSettingOpen] = useState<boolean>(false);

    const [presetConfig, setPresetConfig] = useState<{
        name: string,
        target: string,
        settings: JobSettings,
        llm_generation: boolean,
        highlights_settings: HighlightSettings[],
    }[]>([])

    const [presetSelected, setPresetSelected] = useState<{
        name: string,
        target: string,
        settings: JobSettings,
        llm_generation: boolean,
        highlights_settings: HighlightSettings[],
    } | undefined>(undefined)



    /*Questo serve per gestire l'update. Piattaforma se non riceve lo stesso id per l'highlight settings ne creerebbe uno nuovo, quindi prima di togliere l'highlight setting va memorizzato l'id
    nell'eventaule caso che l'utente lo riaggiunge dopo*/
    const [highlightSettingId, setHighlightSettingId] = useState<Record<SupportedHighlightTypes, string>>({Fast:'', Pistolero: '', Regular: ''});

    const [popupPresetName, setPopupPresetName] = useState<boolean>(false)
    const [popupChoose, setPopupChoose] = useState<boolean>(true)

    async function loadJobOptions(eventId: string): Promise<void> {
        try{
            setJobOptionsLoading(true);
            const jobOptions = await getJobOptions(eventId)
            const sourceDataSources = jobOptions.dataSourcesOptions.filter((dt: DataSource) => dt.type === 'stream' || dt.type === 'file')
            const feedDataSources = jobOptions.dataSourcesOptions.filter((dt: DataSource) => dt.type === 'data_feed')
            setSourceDataSourcesOptions(sourceDataSources)
            setFeedDataSourcesOptions(feedDataSources)
            setTargetOptions(jobOptions.targetOptions)
            setTagOptions(jobOptions.tagOptions)
            setNeedKafka(jobOptions.needKafka)
            if (mode === 'create') {
                let atLeastOneAutoSelection = false
                const tempJob = {...job}
                if(sourceDataSources.length === 1){
                    atLeastOneAutoSelection = true
                    setJobDataSource(tempJob, 'source', sourceDataSources[0].id, sourceDataSources[0])
                }
                if(feedDataSources.length === 1){
                    atLeastOneAutoSelection = true
                    setJobDataSource(tempJob, 'feed', feedDataSources[0].id, feedDataSources[0])
                }
                if(atLeastOneAutoSelection){
                    setJob(tempJob)
                }
            }

        }catch (e){
            console.error(e)
        }finally {
            setJobOptionsLoading(false);
        }
    }

    async function loadSocialOptions(): Promise<void> {
        try{
            setJobOptionsLoading(true);
            const socialOptions = await getSocialOptions();
            setSocialOptions(socialOptions)
        }catch (e){
            console.error(e)
        }
    }

    useEffect(() => {
        loadJobOptions(eventId)
        loadSocialOptions();
    }, []);

    useEffect(() => {
        getPresetConfigs().then(presets => {
            setPresetConfig(presets)
        })
    }, []);



    function handleHighlightTypeChange(type: SupportedHighlightTypes, highlightTypeIndex:number, selected: boolean) {
        const tempJob = {...job};
        if (selected){
            const newHighlightType: HighlightSettings = {...HighlightTypeObjects[type]}
            if (highlightSettingId[type]){
                newHighlightType.id = highlightSettingId[type]
            }
            tempJob.highlights_settings.splice(highlightTypeIndex, 0, newHighlightType);
            setJob(tempJob);
        }
        if (!selected && job.highlights_settings.length > 1){
            const deleteIndex = job.highlights_settings.findIndex(htSetting => htSetting.type === type);
            const removedSetting = tempJob.highlights_settings.splice(deleteIndex, 1)[0];
            setJob(tempJob);
            setHighlightSettingId(prevState => ({...prevState, [type]: removedSetting.id ? removedSetting.id : '' }))
        }
    }

    function handleJobChangeField(fieldName: keyof FormJob, fieldValue: string | null | Dayjs){
        if(fieldName !== 'target'){
            setJob(prevJob => ({...prevJob, [fieldName]: fieldValue}));
        }else{
            const targetValue = fieldValue as string
            if (fieldValue === 'highlights' && job.highlights_settings.length === 0){
                setJob(prevJob => ({
                    ...prevJob, [fieldName]: targetValue,
                    highlights_settings: JSON.parse(JSON.stringify(defaultJobData.highlights_settings))
                }));
            }else{
                setJob(prevJob => ({...prevJob, [fieldName]: targetValue}));
            }
        }

    }

    function handleGeneralSettingChange(fieldName: keyof JobSettings, fieldValue: string | number){
        const tempJob = {...job} as any
        tempJob.settings[fieldName] = fieldValue;
        setJob(tempJob)
    }

    function handleChangeSettings(settingType: 'events_of_interest' | 'skills', settingIndex: number, fieldName: keyof EventOfInterest, fieldValue: string | number | boolean){
        try{
            const tempJob = {...job} as any
            tempJob.settings[settingType][settingIndex][fieldName] = fieldValue
            setJob(tempJob)
        }catch (error){
            console.error("Problems to update settings", {job, settingIndex, fieldName, fieldValue, error})
        }
    }

    function setJobTrack(job: FormJob, track: PlatformTrack, type: 'video' | 'audio'){
        const jobTracks = job.tracks
        const trackIndex = jobTracks.findIndex(track => track.role === trackRoles[type] )
        if (trackIndex > -1) {
            job.tracks[trackIndex] = {
                "track": {
                    "id": (track.id as string)
                },
                "role": trackRoles[type]
            }
        }else{
            job.tracks.push({
                "track": {
                    "id": (track.id as string)
                },
                "role": trackRoles[type]
            })
        }
    }

    function setJobDataSource(tempJob: FormJob, type: 'source' | 'feed', datasourceId: string, dataSource?: DataSource){
        let tempDS = type === 'source' ? sourceDataSourcesOptions.find(ds => ds.id === datasourceId) : feedDataSourcesOptions.find(ds => ds.id === datasourceId);
        tempDS = tempDS === undefined ? dataSource : tempDS;
        if (tempDS) {
            const jobDS = tempJob.data_sources
            const dsIndex = jobDS.findIndex(ds => ds.role === datasourceRoles[type] )
            if (dsIndex > -1) {
                tempJob.data_sources[dsIndex] = {
                    "source": {
                        "id": (tempDS.id as string)
                    },
                    "role": datasourceRoles[type]
                }
            }else{
                tempJob.data_sources.push({
                    "source": {
                        "id": (tempDS.id as string)
                    },
                    "role": datasourceRoles[type]
                })
            }
        }
        if (type === 'source'){
            const sourceDS = tempDS as DataSource
            const tempVideoTracks = sourceDS.tracks ? sourceDS.tracks.filter((track: PlatformTrack) => track.type === 'video').map(track => ({...track, label: track.info.index})) : []
            const tempAudioTracks =   sourceDS.tracks ? sourceDS.tracks.filter((track: PlatformTrack) => track.type === 'audio').map(track => ({...track, label: track.info.index})) : []
            if (tempVideoTracks.length === 1){
                setJobTrack(tempJob, tempVideoTracks[0], 'video')
                setJobTrack(tempJob, tempAudioTracks[0], 'audio')
            }
            if (sourceDS.push && !tempJob.push_schedule){
                const extractionSchedule = dayjs(job.extraction_schedule);
                const pushSchedule = extractionSchedule.subtract(1,'hours');
                tempJob.push_schedule = pushSchedule.toDate()
            }else{
                tempJob.push_schedule = null
            }
        }
    }

    function handleDataSourceChange(type: 'source' | 'feed', datasourceId: string){
        const tempJob = {...job}
        setJobDataSource(tempJob, type, datasourceId)
        setJob(tempJob)
    }

    function handleTrackChange(type: 'audio' | 'video', trackId: string){
        const tempJob = {...job}
        const sourceDS = getSelectedDataSource('source') as DataSource | undefined
        if (sourceDS && sourceDS.tracks){
            const tempTrack =  sourceDS?.tracks.find(track => track.id === trackId);
            if (tempTrack) {
                setJobTrack(tempJob, tempTrack, type)
                setJob(tempJob)
            }
        }

    }

    function getSelectedDataSource(type: 'source' | 'feed'){
        const selectedJobDS = job.data_sources.find(ds => ds.role === datasourceRoles[type])
        if (selectedJobDS) {
            const jobDS = type === 'source' ? sourceDataSourcesOptions.find(ds => ds.id === selectedJobDS.source.id) : feedDataSourcesOptions.find(ds => ds.id === selectedJobDS.source.id)
            return jobDS ? jobDS : ''
        }else{
            return ''
        }
    }

    function getSelectedTracks(type: 'video' | 'audio'){
        const selectedJobTrack = job.tracks.find(track => track.role === trackRoles[type])
        const sourceDS = getSelectedDataSource('source') as DataSource | undefined
        if (selectedJobTrack && sourceDS && sourceDS.tracks) {
            const jobTrack =  sourceDS.tracks.find(ds => ds.id === selectedJobTrack.track.id)
            return jobTrack ? jobTrack : ''
        }else{
            return ''
        }
    }

    function getTracksOptions(type: 'audio' | 'video'){
        const sourceDS = getSelectedDataSource('source') as DataSource | undefined;
        if (sourceDS) {
            return sourceDS.tracks ? sourceDS.tracks.filter((track: PlatformTrack) => track.type === type).map(track => ({...track, label: track.info.index})) : []
        }else{
            return []
        }
    }

    function handleIncludeAllSkills(allSkillIncluded: boolean){
        if(allSkillIncluded){
            const tempJob = {...job}
            tempJob.settings.skills = tempJob.settings.skills.map(evt => ({...evt, included: true}))
            setJob(tempJob)
        }
        setAllSkillSelected(allSkillIncluded)
    }

    const handleChangeEnableAutoPublicationAllEvents = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEnableAutoPublicationAllEvents(event.target.checked);
        const tempSettingClip = {...job.settings}
        if (event.target.checked) {
            tempSettingClip.events_of_interest.map((row, index) => {
                if (row.included)
                    row.auto_publication = true
            })
            tempSettingClip.skills.map((row) => {
                if (row.included)
                    row.auto_publication = true
            })
        }

        setJob((prevState) => ({
            ...prevState,
            settings: tempSettingClip
        }));
    }

    function valueLabelFormat(minutes: number) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = Math.floor(minutes % 60);

        const formattedMinutes = String(hours).padStart(2, '0');
        const formattedSeconds = String(remainingMinutes).padStart(2, '0');


        if ((formattedSeconds) === "31") {
            return "Auto";
        }

        return `${formattedMinutes}:${formattedSeconds}`;
    }

    function handleOpenerCloserSelection(type: 'opener' | 'closer', addOn: OpenerCloserObject){
        const tempFormJob = {...job};
        tempFormJob[type] = addOn;
        setJob(tempFormJob);
    }

    function handleAutoPublicationTeamChange(type: 'home' | 'away', value: boolean){
        const tempJob = {...job};
        if (tempJob.hooks && tempJob.hooks[0]) {
            const socialHook = tempJob.hooks[0]
            if (!value && !socialHook.team){
                socialHook.team = type === 'home' ? 'away' : 'home'
            }
            if (value){
                socialHook.team = null
            }
            setJob(tempJob);
        }
    }


    function getAutoPublicationTeam(type: 'home' | 'away'){
        if (job.hooks && job.hooks[0]){
            const autoPubHook = job.hooks[0]
            if (!autoPubHook.team) {
                return true
            }
            if (autoPubHook.team === 'home') {
                return type === 'home'
            }
            if (autoPubHook.team === 'away') {
                return type === 'away'
            }
        }
        return false
    }

    function getEnableAutoPublication() {
        return Boolean(job.hooks && job.hooks[0])
    }

    function handleChangeEnablePresets(enable: boolean) {
        const tempJob = {...job};

        tempJob.save_conf = enable;

        setJob(tempJob);

    }

    function handleChangeNamePresets(name_conf: string) {
        const tempJob = {...job};


        tempJob.conf_name = name_conf;
        setJob(tempJob);

    }


    function handleEnableAutoPublicationChange(checked: boolean) {
        const tempJob = {...job};
        if (checked) {

            const hooks = job.hooks ?? [];  // fallback to empty array
            const jobId = job.id ?? "";

            let methods = undefined
            if (mode === "update") {
                if (hooks.length === 0) {
                    methods = ["social_clip_create", "social_clip_delete", "social_highlight_create", "social_highlight_delete"]
                } else {
                    methods = hooks[0].methods
                }
            }

            let hookId = undefined
            if (mode === "update") {
                if (hooks.length === 0) {
                    hookId = undefined
                } else {
                    hookId = hooks[0].id
                }
            }

            tempJob['hooks'] = [
                {
                    social_account_id: '',
                    post_type: '',
                    team: null,
                    key_moment_types: [],
                    id: hookId,
                    job_id: mode === "update" ? jobId : undefined,
                    methods: methods
                },
            ]
        }else{
            tempJob['hooks'] = []
        }
        setJob(tempJob);
    }

    function getSocialPlatform(){
        if(job.hooks && job.hooks[0]){
            const socialAccountId = job.hooks[0].social_account_id
            const socialAccount = socialOptions?.socialAccounts.find(account => account.id === socialAccountId)
            if (socialAccount){
                return socialOptions?.socialPlatforms.find(platform => platform.id === socialAccount.socialPlatform)
            }
        }
    }

    function getSocialAccount(){
        if(job.hooks && job.hooks[0]){
            const socialAccountId = job.hooks[0].social_account_id
            const account = socialOptions?.socialAccounts.find(account => account.id === socialAccountId)
            return account ? account : null
        }
        return null
    }

    function getSocialPostType(){
        if(job.hooks && job.hooks[0]){
            const postTypeValue = job.hooks[0].post_type
            const postType = socialOptions?.socialPostTypes.find(post => post.value === postTypeValue)
            return  postType ? postType : null
        }
        return null
    }

    function handleSocialAccountChange(socialAccount: Option | null){
        if(job.hooks && job.hooks[0]){
            setJob((prevState) => {
                const tempJob = {...prevState};
                tempJob.hooks[0].social_account_id = socialAccount ? socialAccount.id : ''
                return tempJob
            })
        }
    }

    function handleSocialPostTypeChange(socialPostType: Option | null){
        if(job.hooks && job.hooks[0]) {
            setJob((prevState) => {
                const tempJob = {...prevState};
                tempJob.hooks[0].post_type = socialPostType ? socialPostType.value : '';
                return tempJob;
            })
        }
    }

    function isPushSchedule(){
        const selectedSourceDS = getSelectedDataSource('source') as DataSource
        return selectedSourceDS.push
    }

    function isHighlightTypeSelected(type: SupportedHighlightTypes){
        return Boolean(job.highlights_settings.find(htSetting => htSetting.type === type))
    }

    function handleChangeHighlightSetting(type: SupportedHighlightTypes, fieldName: keyof HighlightSettings, fieldValue: any){
        const tempJob = {...job};
        const highlightSetting = tempJob.highlights_settings.find(htSetting => htSetting.type === type)
        if(highlightSetting){
            (highlightSetting as any)[fieldName] = fieldValue
            setJob(tempJob)
        }
    }

    useEffect(() => {
        const pushScheduleDate = dayjs(job.push_schedule);
        const extractionSchedule = dayjs(job.extraction_schedule);
        const sourceDS = getSelectedDataSource('source') as DataSource
        if(sourceDS.push && job.push_schedule && (pushScheduleDate > extractionSchedule)) {
            const newDate = dayjs(job.extraction_schedule).subtract(1,'hours');
            setJob((prevDates) => ({
                ...prevDates,
                push_schedule: newDate.toDate(),
            }));
        }
    }, [job.extraction_schedule]);

    function isSendDisable(){
        if(process.env.REACT_APP_SPORT === 'football'){
            return Boolean(!getSelectedDataSource('source') || !getSelectedDataSource('feed') || !getSelectedTracks('video') || !getSelectedTracks('audio'))
        }else if (process.env.REACT_APP_SPORT === 'basketball') {
            return Boolean(!getSelectedDataSource('source') || !getSelectedTracks('video') || !getSelectedTracks('audio'))
        }
    }

    function getSubmitLabel(){
        if (!submitLabel){
            return (mode === 'create' ? 'Create' : 'Update') + ' Job'
        }else{
            return submitLabel
        }
    }

    useEffect(() => {

       const tempJob = {...job};

       if (presetSelected != undefined) {

           tempJob.target = presetSelected!.target;
         //  tempJob.settings = presetSelected!.settings;
           tempJob.llm_generation = presetSelected!.llm_generation;
          // tempJob.highlights_settings = presetSelected!.highlights_settings

           setJob(tempJob)

       }


    }, [presetSelected]);


    function handleSubmit () {
        const tempJob = {...job};

        if (presetConfig.find(item => item.name === tempJob.conf_name)) {
            setPopupPresetName(true)
        }else{
            onSubmit()
        }


    }

    function handleChangePresetSelected (name : string) {




        const preset = presetConfig.find(item => item.name === name);


        setPresetSelected(preset);

        const tempJob = {...job};

        if (preset != undefined) {

            tempJob.target = preset.target;

            tempJob.settings.offset = preset.settings.offset



            const updatedIndexes = new Set<number>();

            preset.settings.events_of_interest.forEach(presetEvent => {
                const index = tempJob.settings.events_of_interest.findIndex(tempEvent => {
                    return tempEvent.key_moment === presetEvent.key_moment; // oppure qualsiasi criterio tu voglia usare
                });

               tempJob.settings.events_of_interest[index] = presetEvent;
                updatedIndexes.add(index);
            });

            tempJob.settings.events_of_interest.forEach((event, index) => {
                if (!updatedIndexes.has(index)) {

                    tempJob.settings.events_of_interest[index].included = false;

                }
            });

            preset.settings.skills.forEach(presetEvent => {
                const index = tempJob.settings.skills.findIndex(tempEvent => {
                    return tempEvent.key_moment === presetEvent.key_moment; // oppure qualsiasi criterio tu voglia usare
                });

                tempJob.settings.skills[index] = presetEvent;
                updatedIndexes.add(index);
            });

            tempJob.settings.skills.forEach((event, index) => {
                if (!updatedIndexes.has(index)) {

                    tempJob.settings.skills[index].included = false;

                }
            });


            const checkedSkills = tempJob.settings.skills.every(item => item.included === true);


            if (checkedSkills)
                setAllSkillSelected(true)
            else
                setAllSkillSelected(false)

            tempJob.llm_generation = preset.llm_generation;
            tempJob.highlights_settings = preset.highlights_settings

        }


        //console.log(preset)

        setJob(tempJob)


    }

    return (
        <>

            <StyledPopup isOpen={popupPresetName} onClose={() => setPopupPresetName(false)} title={"Preset Overwrite Warning"}
                         fullWidth={false}>
                <Box sx={{
                    width: '100%',
                    border: `1px solid ${theme.palette.lightGrey}`,
                    borderRadius: theme.spacing.xs,
                    padding: theme.spacing.md,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <Box sx={{
                        width: '100%',
                        alignItems: "center",
                        justifyContent: "center",
                    }}>

                        <Typography variant="h6" gutterBottom
                                    style={{color: theme.palette.white, textAlign: 'left'}}>A Preset with this name already exists, do you want to overwrite it?</Typography>
                        <Box
                            sx={{
                                display: "flex",
                                width: '100%',
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Grid container spacing={2} columns={12}>
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <TransparentButton text={"Yes"} width={'100%'} onClick={() => {
                                        setPopupPresetName(false)
                                        onSubmit()
                                    }}></TransparentButton>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <TransparentButton text={"No"} width={'100%'} onClick={() => {
                                        const tempJob = {...job}
                                        tempJob.conf_name = '';
                                        setJob(tempJob);
                                        setPopupPresetName(false)
                                    }}></TransparentButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            </StyledPopup>

            {!jobOptionsLoading && !jobLoading? <Box sx={{
                border: `1px solid ${theme.palette.lightGrey}`,
                borderRadius: theme.spacing.xs,
                padding: theme.spacing.md,
                justifyContent: 'center',
                alignItems: 'center',
                paddingTop: theme.spacing.md,
                paddingBottom: theme.spacing.md,
            }}>
                <form>
                    <Grid container spacing={3} direction={"row"}>

                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                            <FormControl fullWidth={true} sx={{paddingTop: theme.spacing.sm}}>

                            <StyledDropdown
                                options={presetConfig}
                                label={"Load a preset"}
                                id={'preset'}
                                value={presetSelected}
                                displayField={"name"}
                                valueField={'name'}
                                onChange={(event)=>{handleChangePresetSelected(event.target.value)}}
                                paddingBottom={theme.spacing.md}
                            />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                            <FormControl fullWidth={true} sx={{
                                paddingTop: theme.spacing.sm
                            }}>
                                <TextinputField placeholder='Name' label={'Name'} type='text' variant={'outlined'}
                                                value={job.name}
                                                size={'medium'}
                                                onChange={(e) => handleJobChangeField('name', e.target.value)}
                                                name={'name'}
                                                id={"outlined-basic"}
                                                borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                                backgroundColor={'none'}
                                                color={theme.palette.white}
                                                borderColor={theme.palette.white}
                                                borderRadius={theme.border.width.hard}

                                ></TextinputField>
                            </FormControl>
                        </Grid>


                        <Grid item xs={12} sm={12} md={12} lg={needKafka && mode === 'create' ? 3 : 6} xl={needKafka && mode === 'create' ? 3 : 6}>
                            <FormControl fullWidth={true} sx={{paddingTop: theme.spacing.sm}}>
                                <StyledDropdown
                                    paddingBottom={theme.spacing.md}
                                    options={targetOptions}
                                    label="Select the target"
                                    id='outlined' value={job.target}
                                    onChange={(event) => handleJobChangeField('target', event.target.value)}
                                />
                            </FormControl>
                        </Grid>
                        {needKafka && mode === 'create' &&
                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                <FormControl fullWidth={true} sx={{
                                    paddingTop: theme.spacing.md
                                }}>

                                    <FormControlLabel
                                        sx={{color: theme.palette.white, marginLeft: '0px'}}
                                        control={
                                            <StyledCheckBox
                                                checked={Boolean(job.kafka_hook)}
                                                onChange={(e) => handleJobChangeField('kafka_hook', (e.target as any).checked)}
                                            />
                                        }
                                        label={'Enable Kafka Publication'}
                                    />
                                </FormControl>
                            </Grid>
                        }
                    </Grid>

                    <Grid container spacing={3} direction={"row"}>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <FormControl fullWidth={true} sx={{
                                paddingTop: theme.spacing.sm
                            }}>
                                <StyledTextarea placeholder={'Description'} label={'Description'} maxRows={4}
                                                value={job.description}
                                                paddingBottom={theme.spacing.md} onChange={(e) => handleJobChangeField('description', e.target.value)}/>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            { isPushSchedule() ? (
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <FormControl fullWidth
                                                     sx={{paddingBottom: theme.spacing.sm,
                                                         paddingTop: theme.spacing.sm
                                                     }}>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                <StyledDataTimePicker label={'Extraction Schedule'}
                                                                      value={dayjs(job.extraction_schedule)}
                                                                      borderFocusColor={theme.palette.orange}
                                                                      borderColor={theme.palette.white}

                                                                      onChange={(e) => handleJobChangeField('extraction_schedule', e)}/>

                                            </LocalizationProvider>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <FormControl fullWidth
                                                     sx={{paddingBottom: theme.spacing.sm,
                                                         paddingTop: theme.spacing.sm
                                                     }}>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                <StyledDataTimePicker label={'Push Schedule'}
                                                                      value={dayjs(job.push_schedule)}
                                                                      borderFocusColor={theme.palette.orange}
                                                                      borderColor={theme.palette.white}
                                                                      maxDateTime={dayjs(job.extraction_schedule)}
                                                                      onChange={(e) => handleJobChangeField('push_schedule', e)}/>

                                            </LocalizationProvider>
                                        </FormControl>

                                    </Grid>
                                </Grid>
                            ) : (

                                <FormControl fullWidth
                                             sx={{paddingBottom: theme.spacing.sm,
                                                 paddingTop: theme.spacing.sm
                                             }}>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>

                                        <StyledDataTimePicker label={'Extraction Schedule'}
                                                              value={dayjs(job.extraction_schedule)}
                                                              borderFocusColor={theme.palette.orange}
                                                              borderColor={theme.palette.white}
                                                              onChange={(e) => handleJobChangeField('extraction_schedule', e)}/>

                                    </LocalizationProvider>
                                </FormControl>


                            ) }

                            <FormControl fullWidth={true}>
                                <StyledAutocomplete freeSolo={true} name={'tags'} label={'Create tag'}
                                                    onChange={(_, newValue) => handleJobChangeField('tag', newValue)}
                                                    value={job.tag !== null ? job.tag : []}
                                                    options={tagOptions}/>
                            </FormControl>
                        </Grid>

                    </Grid>


                </form>

                <Box sx={{
                    border: `1px solid ${theme.palette.lightGrey}`,
                    borderRadius: theme.spacing.xs,
                    padding: theme.spacing.md,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: theme.spacing.md
                }}>

                    <Grid container spacing={3} direction={"row"}>
                        <Grid item xs={12} sm={12} md={12} lg={dataSourceGridSize} xl={dataSourceGridSize}>
                            <FormControl fullWidth={true} sx={{
                                paddingTop: theme.spacing.sm
                            }}>
                                <StyledDropdown
                                    paddingBottom={theme.spacing.sm}
                                    options={sourceDataSourcesOptions}
                                    label="Select the source"
                                    id='outlined'
                                    displayField={"name"}
                                    valueField={"id"}
                                    value={getSelectedDataSource('source')}
                                    onChange={(e) => handleDataSourceChange('source', e.target.value)}/>
                            </FormControl>
                        </Grid>
                        {isDataFeedNeeded && <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                            <FormControl fullWidth={true} sx={{
                                paddingTop: theme.spacing.sm
                            }}>
                                <StyledDropdown
                                    value={getSelectedDataSource('feed')}
                                    paddingBottom={theme.spacing.sm}
                                    options={feedDataSourcesOptions}
                                    label="Select the feed"
                                    id='outlined'
                                    displayField={"name"}
                                    valueField={"id"}
                                    onChange={(e) => handleDataSourceChange('feed', e.target.value)}/>
                            </FormControl>
                        </Grid>}

                        <Grid item xs={12} sm={12} md={12} lg={dataSourceGridSize} xl={dataSourceGridSize}>
                            <FormControl fullWidth={true} sx={{
                                paddingTop: theme.spacing.sm
                            }}>
                                {getSelectedDataSource('source') && <StyledDropdown
                                    paddingBottom={theme.spacing.sm}
                                    options={getTracksOptions('video')}
                                    label="Main video track"
                                    id='outlined'
                                    value={getSelectedTracks('video')}
                                    displayField={"label"}
                                    valueField={"id"}
                                    onChange={(e) => handleTrackChange('video', e.target.value)}
                                />}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={dataSourceGridSize} xl={dataSourceGridSize}>
                            <FormControl fullWidth={true} sx={{
                                paddingTop: theme.spacing.sm
                            }}>
                                {getSelectedDataSource('source') && <StyledDropdown
                                    paddingBottom={theme.spacing.sm}
                                    options={getTracksOptions('audio')}
                                    label="Main audio track"
                                    id='outlined'
                                    value={getSelectedTracks('audio')}
                                    displayField={"label"}
                                    valueField={"id"}
                                    onChange={(e) => handleTrackChange('audio', e.target.value)}/>
                                }
                            </FormControl>
                        </Grid>


                    </Grid>

                </Box>

                {job.target === "highlights" && <Box sx={{
                    marginBottom: theme.spacing.md,
                    border: `1px solid ${theme.palette.lightGrey}`,
                    borderRadius: theme.spacing.xs
                }}>
                        <StyledCollapse title={'Highlights Settings'} onOpen={() => setIsHighlightSettingOpen(true)} onClose={() => setIsHighlightSettingOpen(false)}>
                            {visibleHighlightTypes.length > 1 && <Grid container>
                                {visibleHighlightTypes.map((highlightType, index) => (
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            sx={{
                                                color: theme.palette.white,
                                                marginLeft: '0px',
                                                '&.Mui-disabled .MuiFormControlLabel-label': {
                                                    color: theme.palette.lightGrey,
                                                }
                                            }}
                                            control={
                                                <StyledCheckBox
                                                    height={'20px'}
                                                    width={'20px'}
                                                    iconSize={'20px'}
                                                    checked={isHighlightTypeSelected(highlightType.type)}
                                                    onChange={(e) => handleHighlightTypeChange(highlightType.type, index, (e.target as any).checked)}
                                                />
                                            }
                                            label={highlightType.label}
                                        />
                                    </Grid>
                                ))}
                            </Grid>}
                            {
                                job.highlights_settings.map((htSetting) => (
                                    <Box marginTop={theme.spacing.md}>
                                        <HighlightSetting
                                            needOpenerCloserSelection={true}
                                            needFadeSelection={htSetting.hasOwnProperty('fade')}
                                            fade={htSetting.fade}
                                            fade_duration={htSetting.fade_duration}
                                            opener={htSetting.opener}
                                            closer={htSetting.closer}
                                            competition={competition}
                                            music={htSetting.music}
                                            needSongSelection={htSetting.hasOwnProperty('music')}
                                            loadOpenerCloserTrigger={isHighlightSettingOpen}
                                            title={`${capitilize(htSetting.type)} Highlight Settings`}
                                            onCloserSelectionChange={closer => handleChangeHighlightSetting(htSetting.type, 'closer', closer )}
                                            onOpenerSelectionChange={opener => handleChangeHighlightSetting(htSetting.type, 'opener', opener )}
                                            onFadeDurationSelectionChange={fade_duration => handleChangeHighlightSetting(htSetting.type, 'fade_duration', fade_duration )}
                                            onFadeSelectionChange={fade => handleChangeHighlightSetting(htSetting.type, 'fade', fade )}
                                            onSongSelectionChange={song => handleChangeHighlightSetting(htSetting.type, 'music', song )}
                                        />
                                    </Box>
                            ))}
                        </StyledCollapse>
                    </Box>
                }


                <Box sx={{
                    marginBottom: theme.spacing.md,
                    border: `1px solid ${theme.palette.lightGrey}`,
                    borderRadius: theme.spacing.xs
                }}>
                    <AutoPublication
                        enableAutoPublication={getEnableAutoPublication()}
                        enableAutoPublicationAllEvents={enableAutoPublicationAllEvents}
                        handleChangeEnableAutoPublication={(e) => handleEnableAutoPublicationChange(e.target.checked)}
                        handleChangeEnableAutoPublicationAllEvents={handleChangeEnableAutoPublicationAllEvents}
                        homeTeamAutoPublication={getAutoPublicationTeam('home')}
                        awayTeamAutoPublication={getAutoPublicationTeam('away')}
                        handleChangeHomeTeamAutoPublication={(e) => handleAutoPublicationTeamChange('home', e.target.checked)}
                        handleChangeAwayTeamAutoPublication={(e) => handleAutoPublicationTeamChange('away', e.target.checked)}
                        socialPlatform={getSocialPlatform() || socialPlatform}
                        socialAccount={getSocialAccount() as Option}
                        socialPostType={getSocialPostType() as Option}
                        onSocialPostTypeChange={handleSocialPostTypeChange}
                        onSocialPlatformChange={setSocialPlatform}
                        onSocialAccountChange={handleSocialAccountChange}
                        socialOptions={socialOptions}
                        loadSocialOptions={false}
                    />
                </Box>


                <Box sx={{
                    marginBottom: theme.spacing.md,
                    border: `1px solid ${theme.palette.lightGrey}`,
                    borderRadius: theme.spacing.xs
                }}>
                   <PreSetsConfig
                       enablePresets={job.save_conf}
                       handleChangeEnablePresets={(e) => handleChangeEnablePresets(e.target.checked)}
                       namePresets={job.conf_name}
                       handleChangeNamePresets={handleChangeNamePresets} />
                </Box>
                
                
                
                <Box sx={{
                    border: `1px solid ${theme.palette.lightGrey}`,
                    borderRadius: theme.spacing.xs,
                    padding: theme.spacing.md,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    <Box sx={{
                        padding: theme.spacing.md,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        display: 'flex',
                    }}>
                        <Box
                            sx={{
                                display: "flex",
                                flex: 1, // Facoltativo: permette a questo elemento di occupare una parte proporzionale dello spazio disponibile
                            }}
                        >
                            <FormControlLabel
                                sx={{
                                    color: theme.palette.white,
                                    width: "100%", // Imposta una larghezza
                                }}
                                control={
                                    <StyledCheckBox
                                        checked={job.llm_generation!}
                                        height={"20px"}
                                        width={"20px"}
                                        iconSize={"25px"}
                                        onChange={(e) => handleJobChangeField('llm_generation', (e.target as any).checked)}
                                    />
                                }
                                label={"Enable LLM"}
                            />
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                flex: 1, // Facoltativo
                                maxWidth: "400px", // Imposta una larghezza massima per limitare lo slider
                            }}
                        >
                            <StyledSlider
                                value={job.settings.offset}
                                onChange={(_, newValue,) => handleGeneralSettingChange('offset',  newValue as number)}
                                valueLabelDisplay={"auto"}
                                formatLabel={valueLabelFormat}
                                min={0}
                                max={15}
                                labelSlider={"Clip Margin"}
                            />
                        </Box>


                    </Box>

                    <Box sx={{
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                        {job.settings.events_of_interest.map((row, index) => {
                            return (
                                <KeyMomentJobComponent
                                    onFieldChange={(fieldName, fieldValue) => handleChangeSettings('events_of_interest' ,index, fieldName, fieldValue)}
                                    onSliderChange={(fieldName, fieldValue) => handleChangeSettings('events_of_interest', index, fieldName, fieldValue)}
                                    showAutoPublication={getEnableAutoPublication()}
                                    disableComponent={false}
                                    eventOfInterest={row}
                                />
                            );
                        })}
                    </Box>
                    <Box>


                        { job.settings.skills && job.settings.skills.length > 0 && <StyledCollapse title={'Skills'} paddingLeft={theme.spacing.none} action={
                            <StyledCheckBoxLabel
                                label={"Include All Skill"}
                                checked={allSkillSelected}
                                height={"20px"}
                                width={"20px"}
                                iconSize={"25px"}
                                onChange={(e) => handleIncludeAllSkills((e.target as any).checked)}/>
                        }>


                            {job.settings.skills && job.settings.skills.map((skill, index) => {
                                return (
                                    <KeyMomentJobComponent
                                        onFieldChange={(fieldName, fieldValue) => handleChangeSettings('skills', index, fieldName, fieldValue)}
                                        onSliderChange={(fieldName, fieldValue) => handleChangeSettings('skills', index, fieldName, fieldValue)}
                                        showAutoPublication={getEnableAutoPublication()}
                                        disableComponent={allSkillSelected}
                                        eventOfInterest={skill}
                                    />
                                );
                            })

                            }
                        </StyledCollapse>}
                    </Box>
                </Box>


                <Box sx={{
                    paddingTop: theme.spacing.md,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                }}>
                    <Box sx={{
                        width: '20%',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                        <TransparentButton
                            text= {getSubmitLabel()}
                            width='100%'
                            onClick={handleSubmit}
                            disabled={isSendDisable()}
                            tooltipText={tooltipText} showTooltip={showTooltip}/>
                    </Box>
                </Box>
            </Box> : <SpinnerBox text="Loading Job Infos…" spinnerSize={40} height={'90vh'}/>}
        </>
    )


}

